import { useQuery, useMutation, useQueryClient, useInfiniteQuery } from '@tanstack/react-query';
import { API_ENDPOINTS } from '../data/client/api-endpoints';
import { increaseStockView, getStockStat, getFaqsData } from './client/stock-stat-client';
import { mapPaginatorData } from '../utils/data-mappers';


export const useStockStatQuery = ({ id, ...params }) => {
  return useQuery({
    queryKey: ["stock-state", id],
    queryFn: () =>
      getStockStat.get({
        id,
        ...params,
      }),
    enabled: !!id, // safety
    staleTime: 5 * 60 * 1000, // cache 5 min
  });
};

export const useFaqsQuery = ({ id, ...params }) => {
  return useQuery({
    queryKey: ["faqs-data", id],
    queryFn: () =>
      getFaqsData.get({
        id,
        ...params,
      }),
    enabled: !!id, // safety
    staleTime: 5 * 60 * 1000, // cache 5 min
  });
};

export const useIncreaseStockView = () => {
  return useMutation({
    mutationFn: increaseStockView
  });
};